// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__2yxnU","google":"Link_google__m7zUS"};